import React from 'react'
import styles from './JumpingDots.module.css'

export const JumpingDots: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.dots}>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
        <span className={styles.dot}></span>
      </div>
    </div>
  )
}

export default JumpingDots
